import { NavigateFunction } from 'react-router'
import { call, fork, put, take } from 'redux-saga/effects'

import { buildHeaders } from '../lib/buildHeaders'
import { addNotification } from '../notifications/notifications-actions'
import { buildBody, getClaimInfo } from './api-claim'
import { claimError, claimSuccess } from './claim-actions'
import { CLAIM_REQUESTING } from './claim-constants'

function* claimInfo(
  claim: string,
  dateOfLoss: string,
  redirectTo: string,
  recaptchaToken: string,
  navigate: NavigateFunction
): Generator<any> {
  try {
    const headers = buildHeaders({
      recaptchaToken: recaptchaToken,
      'Content-Type': 'application/json'
    })
    const body = buildBody(claim, dateOfLoss)
    const claimDetails: any = yield call(getClaimInfo, headers, body)

    if (claimDetails && !claimDetails.isValid)
      throw claimDetails

    yield put(claimSuccess(claimDetails))

    navigate(redirectTo)
  } catch(error: any) {
    if (error.status > 5) {
      navigate(`${window.travURI}maintenance`)
      yield put(claimError())
      return
    }

    if (error.message) {
      yield put(claimError())
      yield put(addNotification({
        name: 'claimError',
        body: error.message,
        severity: 'warning',
        title: 'NO MATCH FOUND'
      }))
    }
  }
  return {}
}

function* verifyClaimInfoWatcher() {
  while(true) {
    const { claim, dateOfLoss, redirectTo, recaptchaToken, navigate } = yield take(CLAIM_REQUESTING)

    yield fork(claimInfo, claim, dateOfLoss, redirectTo, recaptchaToken, navigate)
  }
}

export {
  claimInfo,
  verifyClaimInfoWatcher
}
